export const OWNERS = {
  BEEBE: {
    user_id: "465557925683785728",
    roster_id: 1,
    full_name: "michael beebe",
    first_name: "michael",
    last_name: "beebe",
    city: "Charlotte, NC",
    nfl_team: "Chicago Bears",
    college: "North Carolina",
    dynasty_wins: [],
  },
  EDEL: {
    user_id: "999483425495154688",
    roster_id: 4,
    full_name: "matt edel",
    first_name: "matt",
    last_name: "edel",
    city: "Nashville, TN",
    nfl_team: "Carolina Panthers",
    college: "NC State",
    dynasty_wins: [],
  },
  MANION: {
    user_id: "999497776465637376",
    roster_id: 6,
    full_name: "conner manion",
    first_name: "conner",
    last_name: "manion",
    city: "San Francisco, CA",
    nfl_team: "Chicago Bears",
    college: "North Carolina",
    dynasty_wins: [],
  },
  PECHULONIS: {
    user_id: "999036053916864512",
    roster_id: 3,
    full_name: "drew pechulonis",
    first_name: "drew",
    last_name: "pechulonis",
    city: "St. Petersburg, FL",
    nfl_team: "Carolina Panthers",
    college: "South Carolina",
    dynasty_wins: [],
  },
  RUFF: {
    user_id: "999485385422123008",
    roster_id: 5,
    full_name: "connor ruff",
    first_name: "connor",
    last_name: "ruff",
    city: "Hoboken, NJ",
    nfl_team: "Carolina Panthers",
    college: "Notre Dame",
    dynasty_wins: [],
  },
  WHALEN: {
    user_id: "984904059196956672",
    roster_id: 2,
    full_name: "jimmy whalen",
    first_name: "jimmy",
    last_name: "whalen",
    city: "Nashville, TN",
    nfl_team: "Carolina Panthers",
    college: "NC State",
    dynasty_wins: [],
  },
};
